import {t} from "@lingui/core/macro";

import {View} from "@khanacademy/wonder-blocks-core";
import Link from "@khanacademy/wonder-blocks-link";

import {IsIndexedSearchEnabledForLocale} from "./is-indexed-search-enabled-for-locale.ts";

const ComputerProgramBrowseButton = ({locale}) => {
    if (!IsIndexedSearchEnabledForLocale(locale)) {
        return null;
    }

    const introString = t`Searching for a computer program?`;
    const linkString = t`Browse Projects`;

    const link = (
        <Link href="/computing/computer-programming/browse">{linkString}</Link>
    );

    const withIntro = (
        <span>
            {introString} {link}
        </span>
    );

    return <View>{withIntro}</View>;
};

export default ComputerProgramBrowseButton;
